// extracted by mini-css-extract-plugin
export var alternative = "TestimonialsItem-module--alternative--768c6";
export var article = "TestimonialsItem-module--article--bbf3b";
export var author = "TestimonialsItem-module--author--0b2a2";
export var heading = "TestimonialsItem-module--heading--3188b";
export var image = "TestimonialsItem-module--image--7f478";
export var label = "TestimonialsItem-module--label--dbb08";
export var paragraph = "TestimonialsItem-module--paragraph--c150a";
export var picture = "TestimonialsItem-module--picture--e6b13";